import { useExpenseLoaders } from "../loaders/expenseLoaders"

export const useExpenseTypeHooks = () => {
    const expenseLoaders = useExpenseLoaders()

    const canRemoveExpenseType = async (expenseTypeId: string): Promise<boolean> => {
        const { countExpenses } = expenseLoaders()
        const expensesCount = await countExpenses('expenseTypeId', expenseTypeId)
        return expensesCount === 0
    }

    return {
        canRemoveExpenseType
    }
}
